export const firebaseName = "Bimdatabasev5-01"
// export const bucketName="my_project_data_2025v1"
export const bucketName="my_project_data_2026v1"